import { lazy } from 'react';

export const TeacherAssignmentsPage = lazy(() => import('./TeacherAssignmentsPage'));
